import { useTranslations } from '@vocab/react';
import { Alert, Box, Notice, Text } from 'braid-design-system';
import type { ApolloError } from 'node_modules/@apollo/client';

import translations from '../.vocab';

interface Props {
  error: ApolloError | undefined;
  notesResponseError: boolean;
  attachmentResponseError: boolean;
}

export const NotesAttachmentError = ({
  error,
  notesResponseError,
  attachmentResponseError,
}: Props) => {
  const { t } = useTranslations(translations);

  if (error || (notesResponseError && attachmentResponseError)) {
    return (
      <Box>
        <Alert tone="critical">
          <Text size="xsmall">
            {t("We can't show your notes and attachments right now...")}
          </Text>
        </Alert>
      </Box>
    );
  }
  const getErrorText = () => {
    if (notesResponseError)
      return t(
        "We can't show your notes right now. Try refreshing the page or check back later.",
      );
    if (attachmentResponseError)
      return t(
        "We can't show your attachments right now. Try refreshing the page or check back later.",
      );
  };

  if (notesResponseError || attachmentResponseError) {
    return (
      <Box paddingTop="xsmall" paddingBottom="xsmall">
        <Notice tone="critical">
          <Text size="xsmall">{getErrorText()}</Text>
        </Notice>
      </Box>
    );
  }
  return null;
};
